module.exports = __webpack_public_path__ + "img/Team.762e44af.jpg";